import { useRef, useEffect, useState, useCallback } from "react";

export default function FrequencyRuler({
  font,
  fontSize,
  frequencyMax,
  frequencyMin,
  height,
}) {
  const freqRef = useRef();
  const [freqMin, setFreqMin] = useState(frequencyMin);
  const [freqMax, setFreqMax] = useState(frequencyMax);
  const drawingFont = `${fontSize}px ${font}`;
  const bold = `${Number(fontSize) + 2}px ${font}`;

  const drawHz = useCallback((height) => {
    if (!freqRef?.current) return;
    const ctx = freqRef.current.getContext("2d");
    ctx.clearRect(0, 0, freqRef.current.width, freqRef.current.height);

    // major sections are every 1KHz
    // minor sections are every 200Hz
    const freqWidth = freqMax - freqMin;
    const pixelPerHz = height / freqWidth;

    const majors = [];
    let currentHz = Math.floor(freqMax / 1000) * 1000;
    // console.log(freqWidth, currentHz, pixelPerHz);
    while ((freqMax - currentHz) * pixelPerHz < height) {
      majors.push({
        position: (freqMax - currentHz) * pixelPerHz,
        value: currentHz,
      });
      currentHz -= 1000;
    }

    const minors = [];
    currentHz = Math.floor(freqMax / 200) * 200;
    while ((freqMax - currentHz) * pixelPerHz < height) {
      minors.push({
        position: (freqMax - currentHz) * pixelPerHz,
        value: currentHz,
      });
      currentHz -= 200;
    }

    const minis = [];
    currentHz = Math.floor(freqMax / 50) * 50;
    while ((freqMax - currentHz) * pixelPerHz < height) {
      minis.push({
        position: (freqMax - currentHz) * pixelPerHz,
        value: currentHz,
      });
      currentHz -= 50;
    }

    majors.forEach((major) => {
      ctx.fillStyle = "black";
      ctx.fillRect(0, major.position, 10, 1);
      ctx.fillStyle = "black";
      if (
        (major.position > 40 && major.position < height / 2 - 20) ||
        (major.position > height / 2 + 20 && major.position < height - 20)
      ) {
        ctx.font = drawingFont;
        ctx.fillText(getHzString(major.value), 10, major.position + 4);
      }
    });

    minors.forEach((minor) => {
      ctx.fillStyle = "gray";
      ctx.fillRect(0, minor.position, 7, 1);
    });

    if (minors.length < 16 && height > 200) {
      minis.forEach((minor) => {
        ctx.fillStyle = "gray";
        ctx.fillRect(0, minor.position, 4, 1);
      });
    }

    // Draw top, bottom, and center labels
    ctx.fillStyle = "black";
    ctx.fillText(getHzString(freqMax), 10, 8);
    ctx.fillText(getHzString(freqMin), 10, height - 2);

    ctx.font = bold;
    ctx.fillRect(0, height / 2, 10, 1);
    ctx.fillText(getHzString(freqWidth / 2 + freqMin), 14, height / 2 + 4);
  }, [freqMax, freqMin, drawingFont, bold]);

  const getHzString = (hz) => {
    if (hz < 1000) {
      return hz.toFixed(1) + " Hz";
    } else {
      return (hz / 1000).toFixed(1) + " kHz";
    }
  };

  useEffect(() => {
    setFreqMin(frequencyMin);
    setFreqMax(frequencyMax);
  }, [frequencyMin, frequencyMax]);

  useEffect(() => {
    drawHz(height);
  }, [drawHz,height]);

  return (
    <div
      style={{
        position: "absolute",
        width: "50px",
        top: "0",
        right: "0",
        zIndex: "2",
      }}
    >
      <canvas
        ref={freqRef}
        width={50}
        height={height}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
